(function () {
  'use strict';

  if (window.__hmNlInit) return;
  window.__hmNlInit = true;

  var FORM = '.footer-nlcard__form';
  var SINK_ID = 'FooterNewsletterSink';
  var TIMEOUT = 15000;

  function msgBox(form) {
    return form.querySelector('[data-nl-msg]');
  }

  function show(form, text, isError) {
    var box = msgBox(form);
    if (!box) return;
    box.textContent = text;
    box.classList.toggle('footer-nlcard__msg--error', !!isError);
    box.classList.toggle('footer-nlcard__msg--success', !isError);
    box.hidden = false;
  }

  function sink() {
    var el = document.getElementById(SINK_ID);
    if (el) return el;
    el = document.createElement('iframe');
    el.id = SINK_ID;
    el.name = SINK_ID;
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('tabindex', '-1');
    el.setAttribute('sandbox', 'allow-same-origin allow-forms');
    el.style.cssText =
      'position:fixed;top:0;left:0;width:0;height:0;border:0;opacity:0;visibility:hidden;pointer-events:none;';
    document.body.appendChild(el);
    return el;
  }

  function outcome(frame, form) {
    var href = '';
    var doc = null;
    try {
      href = frame.contentWindow.location.href;
      doc = frame.contentDocument;
    } catch (e) {
      return { state: 'fallback' };
    }
    if (!href || href === 'about:blank') return { state: 'fallback' };
    if (/\/challenge/.test(href)) return { state: 'fallback' };
    var err = doc && form.id ? doc.getElementById(form.id + '-error') : null;
    if (err && err.textContent.trim()) return { state: 'error', text: err.textContent.trim() };
    return { state: 'ok' };
  }

  function nativeSubmit(form) {
    form.removeAttribute('target');
    HTMLFormElement.prototype.submit.call(form);
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target.closest ? e.target.closest(FORM) : null;
      if (!form) return;
      if (form.getAttribute('data-nl-busy') === '1') return;
      form.setAttribute('data-nl-busy', '1');

      var frame = sink();
      form.target = SINK_ID;

      var card = form.closest('[data-nl-card]');
      var btn = form.querySelector('[data-nl-btn]');
      var btnText = form.querySelector('[data-nl-btn-text]');
      if (btnText && !btnText.hasAttribute('data-nl-label')) {
        btnText.setAttribute('data-nl-label', btnText.textContent);
      }
      var original = btnText ? btnText.getAttribute('data-nl-label') : '';
      var box = msgBox(form);
      var keepY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var settled = false;

      if (box) box.hidden = true;
      if (btn) btn.disabled = true;
      if (btnText) btnText.textContent = '…';

      function reset() {
        if (btn) btn.disabled = false;
        if (btnText) btnText.textContent = original;
        form.removeAttribute('target');
        form.removeAttribute('data-nl-busy');
      }

      function done() {
        if (settled) return;
        settled = true;
        frame.removeEventListener('load', done);
        clearTimeout(timer);

        var r = outcome(frame, form);
        if (r.state === 'fallback') {
          reset();
          nativeSubmit(form);
          return;
        }
        if (r.state === 'error') {
          show(form, r.text, true);
        } else {
          var input = form.querySelector('.footer-nlcard__input');
          if (input) {
            input.value = '';
            input.blur();
          }
          show(form, (card && card.getAttribute('data-nl-success')) || 'Thanks for subscribing', false);
        }
        reset();
        if (Math.abs((window.pageYOffset || 0) - keepY) > 2) window.scrollTo(0, keepY);
      }

      var timer = setTimeout(done, TIMEOUT);
      frame.addEventListener('load', done);
    },
    true
  );
})();
